export class Animations {
    public static readonly spring = { stiffness: 1000, damping: 75 };
}